<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            :range="true"
            defaultStart="-1M"
            defaultEnd="0M"
            label="기간"
            name="period"
            v-model="searchParam.period"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            type="search"
            :comboItems="stepItems"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="sopFireFightingPermitStepCd"
            label="진행단계"
            v-model="searchParam.sopFireFightingPermitStepCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <q-table
      grid
      title=""
      :data="grid.data"
      :columns="grid.columns"
      hide-header
      hide-bottom
      :rows-per-page-options="[0]"
      virtual-scroll
    >
      <template v-slot:item="props">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
          <q-card class="mobileTableCardLayer" @click="linkClick(props.row)">
            <q-card-section class="grid-card-etc">
              <div :class="['text-grid-etc', 'txt-box-grid text-primary-box']">
                {{ props.row.permitNo }}
              </div>
              <div :class="['text-grid-etc', 'txt-box-grid text-positive-box']">
                {{ props.row.permitDt }}
              </div>
              <div :class="['text-grid-etc', 'txt-box-grid text-gray-box']">
                {{ props.row.sopFireFightingPermitStepName }}
              </div>
            </q-card-section>
            <q-card-section>
              <div class="text-grid-title q-mt-sm q-mb-xs">{{ props.row.workSummary }}</div>
            </q-card-section>
          </q-card>
        </div>
      </template>
    </q-table>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" v-if="grid.data.length === 0">
      <q-card class="mobileTableCardLayer">
        <q-card-section horizontal class="bg-grey-2 text-center">
          <q-card-section class="q-pt-xs">
            <div class="text-grid-title q-mt-sm q-mb-xs">데이터가 존재하지 않습니다.</div>
          </q-card-section>
        </q-card-section>
      </q-card>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import mixinFooterSearch from '@/js/mixin-footer-search-common'
export default {
  name: 'fireFightingPermit',
  mixins: [mixinFooterSearch],
  data() {
    return {
      searchParam: {
        plantCd: null,
        period: [],
        sopFireFightingPermitStepCd: null,
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            name: 'permitNo',
            field: 'permitNo',
            label: '허가번호',
            align: 'center',
            sortable: true,
            style: 'width: 90px',
            type: 'link'
          },
          {
            name: 'workSummary',
            field: 'workSummary',
            label: '작업개요',
            align: 'left',
            sortable: true,
            style: 'width: 250px',
            type: 'link'
          },
          {
            name: 'permitDt',
            field: 'permitDt',
            label: '작업일시',
            align: 'center',
            sortable: true,
            style: 'width: 150px',
          },
          {
            name: 'workManagerName',
            field: 'workManagerName',
            label: '작업책임자',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            name: 'confirmDate',
            field: 'confirmDate',
            label: '확인일',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            name: 'sopFireFightingPermitStepName',
            field: 'sopFireFightingPermitStepName',
            label: '진행상태',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
        ],
        data: [],
      },
      stepItems: [],
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  beforeRouteLeave(to, from, next) { // history.back 일경우 팝업이라면 팝업을 닫자
    if (this.popupOptions.visible) {
      this.closePopup();
      next(false);
    } else {
      next();
    }
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.fft.fireFightingPermit.list.url
      // code setting
      this.$comm.getStepItems('SOP_FIRE_FIGHTING_PERMIT_STEP_CD').then(_result => {
        this.stepItems = this.$_.concat([{
          stepperMstNm: '미확인',
          stepperMstCd: 'NONE',
        }], _result)
      });
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.popupOptions.title = '소방 공사 상세';
      this.popupOptions.param = {
        sopWorkPermitId: row ? row.sopWorkPermitId : '',
      };
      this.popupOptions.target = () => import(`${'./fireFightingPermitDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
